import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, Drawer, Form, Input, Select, Space, Table, Tag, Typography, App } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api, apiError } from '@/lib/api';
import { useAuthStore } from '@/lib/auth-store';
const RESTRICT_LABEL = {
    UNRESTRICTED: 'Tanpa Pembatasan',
    TEMP_RESTRICTED: 'Terikat Sementara',
    PERM_RESTRICTED: 'Terikat Permanen',
};
export function FundsPage() {
    const { message } = App.useApp();
    const qc = useQueryClient();
    const hasPerm = useAuthStore((s) => s.hasPerm);
    const [drawer, setDrawer] = useState(false);
    const [form] = Form.useForm();
    const q = useQuery({
        queryKey: ['funds'],
        queryFn: async () => (await api.get('/funds')).data,
    });
    const createMut = useMutation({
        mutationFn: async (v) => (await api.post('/funds', v)).data,
        onSuccess: () => {
            message.success('Dana ditambahkan');
            qc.invalidateQueries({ queryKey: ['funds'] });
            setDrawer(false);
        },
        onError: (e) => message.error(apiError(e)),
    });
    const cols = [
        { title: 'Kode', dataIndex: 'code', width: 120 },
        { title: 'Nama', dataIndex: 'name' },
        {
            title: 'Sifat Pembatasan',
            dataIndex: 'restriction',
            render: (r) => _jsx(Tag, { color: "purple", children: RESTRICT_LABEL[r] ?? r }),
        },
        {
            title: 'Status',
            dataIndex: 'is_active',
            width: 100,
            render: (a) => (a ? _jsx(Tag, { color: "success", children: "Aktif" }) : _jsx(Tag, { children: "Nonaktif" })),
        },
    ];
    return (_jsxs("div", { children: [_jsxs(Space, { style: { marginBottom: 16, display: 'flex', justifyContent: 'space-between' }, children: [_jsx(Typography.Title, { level: 3, style: { margin: 0 }, children: "Dana (PSAK 45)" }), hasPerm('fund:manage') && (_jsx(Button, { type: "primary", icon: _jsx(PlusOutlined, {}), onClick: () => setDrawer(true), children: "Tambah Dana" }))] }), _jsx(Table, { rowKey: "id", loading: q.isLoading, dataSource: q.data ?? [], columns: cols, pagination: false, size: "middle" }), _jsx(Drawer, { open: drawer, onClose: () => setDrawer(false), title: "Tambah Dana", width: 420, destroyOnClose: true, extra: _jsx(Button, { type: "primary", loading: createMut.isPending, onClick: () => form.validateFields().then((v) => createMut.mutate(v)), children: "Simpan" }), children: _jsxs(Form, { form: form, layout: "vertical", preserve: false, children: [_jsx(Form.Item, { name: "code", label: "Kode", rules: [{ required: true }], children: _jsx(Input, { placeholder: "mis. UMUM" }) }), _jsx(Form.Item, { name: "name", label: "Nama", rules: [{ required: true }], children: _jsx(Input, {}) }), _jsx(Form.Item, { name: "restriction", label: "Sifat Pembatasan", rules: [{ required: true }], children: _jsx(Select, { options: Object.entries(RESTRICT_LABEL).map(([v, l]) => ({ value: v, label: l })) }) })] }) })] }));
}
